<template>

        <ul class="school flex-between">
            <li class="school-li"
                v-for="(li,index) in lists" 
                :key="index"
                >
                <img :src="li.imgURL" alt="" @click="goPage(li.href)">
                <div class="describe">
                    <h3 class="f16 wes-2">{{li.name}}</h3>
                </div>
            </li>
        </ul>

</template>

<script>
export default {
    props: {
        cloumn: {
          type:Number
        },
    },
    data() {
        return {
            lists:[{
                imgURL:require('../../../assets/yunqiao/shoushi01.png'),
                name:'名校联盟双师课堂',
                href:'/project_detail/6'
            },
            {
                imgURL:require('../../../assets/yunqiao/shoushi02.png'),
                name:'全学科互联网+项目式学习',
                href:'/project_detail/2'
            },{
                imgURL:require('../../../assets/yunqiao/shoushi03.png'),
                name:'课堂行为大数据分析',
                href:'/project_detail/4'
            },{
                imgURL:require('../../../assets/yunqiao/lezhi01.png'),
                name:'一带一路共读工程',
                href:'/project_detail/1'
            },{
                imgURL:require('../../../assets/yunqiao/lezhi02.png'),
                name:'STEAM课程',
                href:'/project_detail/8'
            },{
                imgURL:require('../../../assets/yunqiao/lezhi03.png'),
                name:'中小学生计算思维培养课程',
                href:'/project_detail/3'
            },{
                imgURL:require('../../../assets/yunqiao/lezhi04.png'),
                name:'教师信息化水平提升',
                href:'/project_detail/5'
            },{
                imgURL:require('../../../assets/yunqiao/lezhi05.png'),
                name:'中小学综合素质评价',
                href:'/project_detail/7'
            }]
        }
    },
    methods: {
        goPage(url) {
            // Common.goPage(url, this);
        }
    }
}
</script>

<style lang="less" scoped>
    .school {
        flex-flow: row wrap;
        align-content: flex-start;

        .school-li {
            margin-bottom: 20px;
            // cursor: pointer;

            &:hover .describe{
                // color: #114dd7;
            }

            img {
                display: inline-block;

                width: 280px;
                height: 185px;

                background-color: #1c4b90;
                // cursor: pointer;
            }
            .describe {
                flex: 1;
                text-align: center;
                 h3 {
                     padding: 23px 0 0;
                     margin-bottom: 19px;
                 }
            } 
        }

        
        .u-lof4 {
            flex: 0 0 24%;
        }

        .u-lof3 {
            flex: 0 0 33%;
        }

        .u-lof2 {
            flex: 0 0 50%;
            .describe {
                padding: 0 20px;
            }



        }
    }
</style>